var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProceduralguide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "procedural_guide_icon",
    "data-name": "procedural guide icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26955",
    "data-name": "Group 26955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10426",
    "data-name": "Path 10426",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26956",
    "data-name": "Group 26956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10427",
    "data-name": "Path 10427",
    d: "M13.17,2H6A2.006,2.006,0,0,0,4,4V20a2.006,2.006,0,0,0,2,2H18a2.006,2.006,0,0,0,2-2V8.83a1.966,1.966,0,0,0-.59-1.41L14.58,2.59A1.966,1.966,0,0,0,13.17,2ZM16,15a4,4,0,0,1-4.39,3.98A4.116,4.116,0,0,1,8,14.83V9.64a2.6,2.6,0,0,1,2.24-2.63A2.5,2.5,0,0,1,13,9.5V14a1,1,0,0,1-1,1h0a1,1,0,0,1-1-1V9.5a.5.5,0,0,0-1,0v5.39a2.072,2.072,0,0,0,1.66,2.08A2,2,0,0,0,14,15V12a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1ZM14,7V4l4,4H15A1,1,0,0,1,14,7Z",
    fill: "#f0f0f0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProceduralguide);
export default __webpack_public_path__ + "static/media/proceduralguide.06cde4471af79d2fcd8343b58fb7f8d2.svg";
export { ForwardRef as ReactComponent };